import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormImportInstance,
  title: 'Form Import Instance',
  category: ComponentCategory.FormControls,
};
